import { Booking } from '../models/booking';
import { Passenger } from '../models/passenger';

export interface API {
  login(pnr: string, lastName: string): Promise<LoginResponse>;
  redeemVoucher(pnr: string, lastName: string, passenger: Passenger): Promise<RedeemVoucherResponse>;
  sendVoucher(toAddress: string, pnr: string, lastName: string, passenger: Passenger): Promise<SendVoucherResponse>;
}

export const nonFieldErrorsKey = '__all__';

export interface APIResponse422 {
  readonly errors: APIErrorMap<string>;
}

export type APIErrorMap<K extends string> = {
  readonly [P in K]?: APIFieldErrors;
};

export type APIFieldErrors = ReadonlyArray<string>;

export interface ValidationErrorResponse<K extends string> {
  readonly status: 'validation-error';
  readonly errors: APIErrorMap<K>;
}

export interface UnexpectedErrorResponse {
  readonly status: 'unexpected-error';
}

export interface NetworkErrorResponse {
  readonly status: 'network-error';
}

export interface APILoginRequest {
  readonly pnr: string;
  readonly last_name: string;
}

export interface LoginResponseSuccessful {
  readonly booking: Booking;
  readonly status: 'ok';
}

export type LoginResponse =
  | { readonly status: 'not-found' }
  | { readonly status: 'ineligible' }
  | { readonly status: 'expired' }
  | LoginResponseSuccessful
  | ValidationErrorResponse<LoginValidationErrorKeys>
  | NetworkErrorResponse
  | UnexpectedErrorResponse;

export type LoginValidationErrorKeys = 'pnr' | 'last_name';

export interface APIRedeemVoucherRequest {
  readonly pnr: string;
  readonly last_name: string;
  readonly passenger_id: number;
}

export type RedeemVoucherResponse =
  | RedeemVoucherResponseSuccess
  | NetworkErrorResponse
  | UnexpectedErrorResponse;

export interface RedeemVoucherResponseSuccess {
  readonly status: 'ok';
  readonly passenger: Passenger;
}

export type SendVoucherValidationErrorKeys = 'to_address';

export interface APISendVoucherRequest {
  readonly to_address: string;
  readonly pnr: string;
  readonly last_name: string;
  readonly passenger_id: number;
}

export type SendVoucherResponse =
  | SendVoucherResponseSuccess
  | ValidationErrorResponse<SendVoucherValidationErrorKeys>
  | NetworkErrorResponse
  | UnexpectedErrorResponse;

export interface SendVoucherResponseSuccess {
  readonly status: 'ok';
  readonly passenger: Passenger;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/api/api.ts